import { defineLocale } from "../../registry";

const audit = defineLocale({
  ru: {
    "audit.notice": "Просмотр зафиксирован в Audit Log",
    "audit.signature": "Действие зафиксировано в Audit Log",
  },
  en: {
    "audit.notice": "Viewing is recorded in the Audit Log",
    "audit.signature": "The action is recorded in the Audit Log",
  },
});

export default audit;
